import { post } from "storefront/GrailedAPI/request";
import { Id } from "storefront/lib/Id";
import { GrailedAPIHeavyListing } from "storefront/Listing/GrailedAPIHeavyListing";

type Response = {
  data: GrailedAPIHeavyListing;
};

const unpack = (res: Response): GrailedAPIHeavyListing => res.data;

const favoriteListing = (userId: Id, id: Id): Promise<GrailedAPIHeavyListing> =>
  post<Response>(`/api/users/${userId}/favorites`, {
    id,
  }).then(unpack);

export default favoriteListing;
